module.exports = "/images/0b50b5944bae352920e8544882d22b26.png";